import React, { useState, useEffect } from 'react';
import { Carousel } from 'antd';
import './offerCarousel.css';
import promoImage from '../../Assets/userMarketPlace/promo.svg';
import promoMobImage from '../../Assets/userMarketPlace/promoMob.svg';
import learnersIcon from '../../Assets/userMarketPlace/learners.svg';
import libraryIcon from '../../Assets/userMarketPlace/resources.svg';
import supportIcon from '../../Assets/userMarketPlace/support.png';
import { connect } from 'react-redux';

const OfferCarouselV2 = ({ offersCarouselData, onDownloadClick, fromHomePage, fromStudentCart, fromCourseDetailsPage, userMarketPlaceHomeData }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [copiedIndex, setCopiedIndex] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const carouselSettings = {
    autoplay: true,
    dots: false,
  };



  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    let formattedDate = date.toLocaleDateString('en-US', options);

    // Extract day
    const day = date.getDate();
    const suffix = (day % 10 === 1 && day !== 11) ? "st" :
      (day % 10 === 2 && day !== 12) ? "nd" :
        (day % 10 === 3 && day !== 13) ? "rd" : "th";

    // Format output to match the required structure
    return `Apr ${day}<sup>${suffix}</sup>, 2025`;
  }

  const handleCopyCode = (code, index) => {
    const tempInput = document.createElement('input');
    tempInput.value = code;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    setCopiedIndex(index);
  };

  function formatUserCount(count) {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(1).replace(".0", "") + "M";
    } else if (count >= 100000) {
      return Math.floor(count / 1000) + "K";
    } else if (count >= 1000) {
      return (count / 1000).toFixed(1).replace(".0", "") + "K";
    } else {
      return count; // If below 1000, return as is
    }
  }



  const features = [
    {
      icon: supportIcon,
      value: "24x7",
      text: "support",
    },
  ];

  // if (userMarketPlaceHomeData?.libraryCount > 0) {
    features.unshift({
      icon: libraryIcon,
      value: formatUserCount(userMarketPlaceHomeData?.libraryCount),
      text: "library resources",
    });
  // }

  // if (userMarketPlaceHomeData?.userCount > 0) {
    features.unshift({
      icon: learnersIcon,
      value: formatUserCount(userMarketPlaceHomeData?.userCount),
      text: "learners enrolled",
    });
  // }


  return (
    <div className="offer-carousel-container" style={{ marginTop: isMobile ? 5 : fromStudentCart ? -50 : fromCourseDetailsPage ? 55 : fromHomePage ? 60 : -30 }}>
      <Carousel {...carouselSettings}>
        {offersCarouselData.map((offer, index) => {
          const isCopied = copiedIndex === index;
          return (

            <div key={index}>
              <div className="offer-slide">
                {/* Background Image */}
                <img
                  src={isMobile ? promoMobImage : promoImage}
                  alt="Offer background"
                  className="offer-background"
                  style={{ objectFit: isMobile ? 'contain' : 'cover' }}
                />
                {isMobile ? (
                  <div className="offer-content offer-content-mobile">

                    <div className="offer-mobile-layout">
                      <div className="offer-text-mobile">
                        <div className="offer-heading" style={{ textAlign: 'end' }}>{`Get extra ${offer.discount}${offer.discountType == 'amount' ? '₹' : '%'} off`}</div>
                        {offer.endDate && offer.endDate !== '0000-00-00' ?
                          <span
                            className="offer-subtext"
                            dangerouslySetInnerHTML={{ __html: `Valid till ${formatDate(offer.endDate)}` }}
                          ></span>
                          :
                          <></>}

                      </div>

                      {
                        offer?.code
                          ?
                          <button className="offer-button" style={{ cursor: !isCopied ? 'pointer' : '' }}
                            onClick={() => {
                              handleCopyCode(offer?.code, index);
                            }}
                          >
                            {isCopied ? (
                              <span className='use-promo-font'>Copied!</span>
                            ) : (
                              <>
                                Use code <span style={{ fontWeight: '700' }}>{offer.code}</span>
                              </>
                            )}
                          </button>
                          :
                          <></>
                      }

                    </div>
                  </div>
                ) : (
                  // Desktop View (as currently implemented)
                  <div className="offer-content" style={{}}>
                    <div className="offer-text">
                      <h2 className="offer-heading" style={{ marginLeft: isMobile ? 0 : 25 }}>{`Get extra ${offer.discount}${offer.discountType == 'amount' ? '₹' : '%'} off`}</h2>
                      {offer.endDate && offer.endDate !== '0000-00-00' ?
                        <span
                          className="offer-subtext"
                          dangerouslySetInnerHTML={{ __html: `Offer valid till ${formatDate(offer.endDate)}` }}
                        ></span>
                        :
                        <></>}
                    </div>
                    {offer?.code
                      ?
                      <button className="offer-button" style={{ marginRight: 10, marginTop: -2, cursor: !isCopied ? 'pointer' : '' }}
                        onClick={() => {
                          handleCopyCode(offer?.code, index);
                        }}
                      >
                        {isCopied ? (
                          <span className=''>Copied!</span>
                        ) : (
                          <>
                            Use code <span style={{ fontWeight: '700' }}>{offer.code}</span>
                          </>
                        )}
                      </button>
                      :
                      <></>
                    }

                  </div>
                )}
              </div>
            </div>
          )
        })}
      </Carousel>

      {isMobile && fromHomePage && !fromCourseDetailsPage ?
        <div className="mob-v2">
          <div className="fixed-btn" onClick={onDownloadClick}>
            GET STARTED
          </div>

          <Carousel autoplay dots={false} className="features-carousel">
            {features.map((feature, index) => (
              <div key={index} className="carousel-item">
                <div className="feature-carousel-item">
                  <img src={feature.icon} alt={feature.text} />
                  <div style={{ marginLeft: 10 }}>
                    <div className="" style={{ fontWeight: 'bold', color: '#006cd5', }}>{feature.value}</div>
                    <div style={{ color: '#191919' }}>{feature.text}</div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        :
        fromHomePage && !fromCourseDetailsPage &&
        <div className="banner-container-v2">
          <button className="download-button-v2" onClick={onDownloadClick}>DOWNLOAD OUR APP</button>

          <div className="features-container-v2">
            {/* {userMarketPlaceHomeData?.userCount > 0
              ? */}
              <div className="feature-v2">
                <img src={learnersIcon} alt="Learners" />
                <div >
                  <div style={{ fontSize: 14, color: '#006cd5', fontWeight: 'bold' }}>{formatUserCount(userMarketPlaceHomeData?.userCount)}</div>
                  <p>learners enrolled</p>
                </div>
              </div>
              {/* :
              <></>
            } */}

            {/* {
              userMarketPlaceHomeData?.libraryCount > 0
                ? */}
                <div className="feature-v2">
                  <img src={libraryIcon} alt="Library" />
                  <div>
                    <div style={{ fontSize: 14, color: '#006cd5', fontWeight: 'bold' }}>{formatUserCount(userMarketPlaceHomeData?.libraryCount)}</div>
                    <p>library resources</p>
                  </div>
                </div>
                {/* :
                <></>
            } */}




            <div className="feature-v2">
              <img src={supportIcon} alt="Support" />
              <div>
                <div style={{ fontSize: 14, color: '#006cd5', fontWeight: 'bold' }}>24x7</div>
                <p>support</p>
              </div>
            </div>
          </div>
        </div>
      }



    </div>

  );
};


const mapStateToProps = (state) => {
  const { userMarketPlaceHomeData, } = state.studentMarketPlace;


  return { userMarketPlaceHomeData };
};

const mapDispatchToProps = (dispatch) => ({

});
export default connect(mapStateToProps, mapDispatchToProps)(OfferCarouselV2);

